import React, {useEffect, useState} from "react";

import {useParams} from "react-router-dom";
import {ResponseApiCalls} from "../../apis/ResponseApiCalls";
import WordCloudResult from "../JoinQuizPage/WordCloudResult";
import Skeleton, {SkeletonTheme} from "react-loading-skeleton";
import useWindowDimensions from "../../hooks/useWindowDimensions";

export default function MobileResultPage() {
    const {getClassResult} = ResponseApiCalls();
    const {pollKey, pollCode, serialNo} = useParams();
    // const [isLoading, setIsLoading] = useState(false);
    const [questionResult, setQuestionResult] = useState([]);
    const [dataLoading, setDataLoading] = useState(true);
    const window = useWindowDimensions();

    useEffect(() => {
        const meta = document.createElement('meta');
        meta.setAttribute('content', 'initial-scale=1.0, maximum-scale=1.0, user-scalable=0');
        meta.setAttribute('name', 'viewport');
        document.head.appendChild(meta);

        const getData = async () => {
            let result = await getClassResult(pollKey, pollCode, {serialNo: serialNo}, null, true);
            if (result.length > 0) {
                setQuestionResult(result);
            } else {
                setQuestionResult([]);
            }
        };
        // setIsLoading(true);
        setDataLoading(true);
        getData().finally(() => setDataLoading(false));
        // setIsLoading(false);

        const interval = setInterval(() => {
            getData();
        }, 5000);
        return () => clearInterval(interval);
    }, []);

    return (
        <div style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: window.width,
            height: window.height
        }}>
            {!!dataLoading &&
                <SkeletonTheme color="rgba(237, 237, 237, 1)" highlightColor="lightgrey">
                    <Skeleton borderRadius={6} height={180} width={180}/>
                </SkeletonTheme>
            }
            {!dataLoading &&
                <WordCloudResult
                    data={questionResult}
                    customStyle={{
                        width: window.width,
                        height: window.height,
                        tooltip: false
                    }}
                />
            }
        </div>
    );
}